import React from 'react';
import {Outlet} from 'react-router-dom';

const DataImports: React.FC = () => {
  return <Outlet />;
};

export default DataImports;
